var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLegendsi = function SvgLegendsi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M21 12.2a.72.72 0 0 0-.442-.654l-2.846-1.264 2.846-1.266a.7.7 0 0 0 0-1.308L12.383 4.07a.83.83 0 0 0-.664 0L3.445 7.707a.7.7 0 0 0 0 1.31l2.877 1.265-2.877 1.265a.705.705 0 0 0 0 1.311l2.416 1.062-2.416 1.063a.7.7 0 0 0 0 1.31l8.274 3.638a.8.8 0 0 0 .33.069.8.8 0 0 0 .334-.07l8.175-3.638a.7.7 0 0 0 0-1.308l-2.39-1.064 2.39-1.063A.72.72 0 0 0 21 12.2m-8.953-6.674 6.375 2.836-6.375 2.838L5.6 8.362zm4.331 9.2 2.044.91-6.375 2.838L5.6 15.638l2.067-.908c.005 0 .009-.008.015-.011l4.037 1.781a.8.8 0 0 0 .33.069.8.8 0 0 0 .334-.07l3.985-1.774zm-4.331.311L5.6 12.2l2.48-1.089c.019-.009.031-.025.049-.034l3.59 1.578a.83.83 0 0 0 .664 0l3.539-1.575.043.03 2.457 1.09z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLegendsi);
export default ForwardRef;